import { useContext, createContext } from "react";
export var useArticleHeaderContext = function () {
    var context = useContext(ArticleHeaderContext);
    if (context === undefined) {
        throw new Error("Component is not a child of ArticleHeader");
    }
    return context;
};
export var ArticleHeaderContext = createContext(undefined);
